<template>
  <!-- Or manually control the data synchronization -->
  <span>
  <codemirror
    ref="cmEditor"
    :value="code"
    :options="cmOptions"
    @ready="onCmReady"
    @input="onCmCodeChange"
  />

  </span>
</template>

<script>
import { codemirror } from "vue-codemirror";

// import base style
import "codemirror/lib/codemirror.css";

// import language js
import "codemirror/mode/javascript/javascript.js";

// active-line.js
import "codemirror/addon/selection/active-line.js";

import "codemirror/addon/edit/closebrackets.js";
import "codemirror/addon/edit/matchbrackets.js";

export default {
  props: {
    path: String,
    choosenDeviceType: Object,
    oldCode: String,
  },
  components: {
    codemirror
  },
  data() {
    return {
      cmOptions: {
        firstLineNumber:2,
        readOnly: false,
        tabSize: 4,
        mode: "text/javascript",
        styleActiveLine: true,
        lineNumbers: true,
        line: true,
        autoCloseBrackets: true,
        theme: "default",
        matchBrackets: true
      }
    };
  },
  methods: {
    onCmReady(cm) {
      this.$emit("line",cm.lineCount()+1);
    },
    onCmCodeChange(newCode) {
      this.$emit("line",this.codemirror.lineCount()+1);
      this.$emit("code",newCode);
      this.code = newCode;
    }
  },
  computed: {
    codemirror() {
      return this.$refs.cmEditor.codemirror;
    }
  },
  mounted() {
    this.$emit("code",this.code);
    //console.log("the current CodeMirror instance object:", this.codemirror);
    // you can use this.codemirror to do something...
  },
  beforeMount(){
    this.code = this.oldCode;
  }
};
</script>

